/**
 * OPEN MODAL
 */
$("body").on("click", "#btnNewsletterModal", function(e) {
    e.preventDefault();

    $.ajax({
        url: url('/pacotes-pontos-de-venda/newsletter'),
        type: 'POST',
        beforeSend: () => {
            loaderShow();
        },
        success: (response) => {
            //abre modal
            modalBootstrapShow(
                'md',
                '<span class="text-primary">Receba nossas <b>promoções</b></span>',
                response
            );
            loaderClose();
        }
    });

});

/**
 *
 */
$("body").on("click", "#btnNewsletterSend", function(e) {
    e.preventDefault();

    var contentModal = $('#newsletterModal');
    var messageModal = $('#newsletterModalMessage');

    var form = $('#formNewsletter').serialize();

    $.ajax({
        url: url('/pacotes-pontos-de-venda/newsletter'),
        data: form + '&action=send',
        type: 'POST',
        dataType: 'JSON',
        beforeSend: () => {
            loaderShow();
            messageModal.html('');
        },
        success: (response) => {

            return;
            if (response.message) {
                loaderClose();
                messageModal.html(response.message);
            }

            if (response.success) {
                loaderClose();
                contentModal.html(
                    '<div class="w-100 text-center">' +
                    '<p class="lead"> Cadastrado com sucesso!</p>' +
                    '<button type="button" class="btn btn-primary shadow" data-dismiss="modal">Fechar</button>' +
                    '</div>'
                );
            }

        }
    });

});